/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */

export const createApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createApproval',
  auth: 'app',
  fingerprint: 'TGpLjpvOJNse3UnXNev0nYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createBulkApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'createBulkApproval',
  auth: 'app',
  fingerprint: '9aCv06fL1Hu4GQFLguD7_4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLatestApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getLatestApproval',
  auth: 'app',
  fingerprint: '0CycHdc70V9qT63Mu_KIcYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'getApproval',
  auth: 'app',
  fingerprint: 'tO7k9L9wKAGCd1LPfJnmn4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'approveApproval',
  auth: 'app',
  fingerprint: 'w3LXpRbTttOYPnMAHcZpboT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'rejectApproval',
  auth: 'app',
  fingerprint: 'TCiJepipaVOU9GUF5DxRuYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const requestChangesOnApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'requestChangesOnApproval',
  auth: 'app',
  fingerprint: 'oyjmK_MVwfrIukgr-FwOL4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markChangesResolvedRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'markChangesResolved',
  auth: 'app',
  fingerprint: 'M_iWgCVqu1Pa0bzN_OTCfIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'cancelApproval',
  auth: 'app',
  fingerprint: 'HrDzSXNmqRvos1hPnxFgPIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const concludeApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'concludeApproval',
  auth: 'app',
  fingerprint: 'vPBjW4gk0LhIRwLD1j28LIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateApprovalRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'updateApproval',
  auth: 'app',
  fingerprint: 'I3aHlCZVQ6vBU8H7QgduVYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendReminderNotificationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsRpc',
  rpcName: 'sendReminderNotification',
  auth: 'app',
  fingerprint: 'CLm0NFVWppmLVdc5zf35iYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};